// import { DispatchProp } from 'react-redux';
import axios from 'axios';
import { updateUser } from '../redux/reducers/session';
import { admin_accountsAPI, principal_accountsAPI, usersAPI } from './routes';
import { store } from '../redux/index';
import {
  IAccount,
  IFormSecondaryAccount,
  INewAccount,
  TCallback
} from '../utils/interfaces/interfaces';
import { pick } from 'lodash';

/* administrator calls */
// const getAdminInfo = (id: string) => {
//   axios
//     .get(usersAPI.ADMIN_DATA(id))
//     .then(({ data }) => store.dispatch(updateUser({ user: data })));
// };

const getPrincipalAccounts = (callback: TCallback) => {
  axios
    .get(admin_accountsAPI.PRINCIPAL_ACCOUNTS)
    .then(({ data }) => callback(data.data));
};

const updateAccount = async (account: IAccount) => {
  const newAccount = pick(account, [
    'id',
    'contractExpirationDate',
    'email',
    'firstName',
    'lastName',
    'phone',
    'type',
    'institutionId',
    'institutionName',
    'status',
    'secondaryAccountAllowance'
  ]);
  await axios.put(admin_accountsAPI.MODIFY_PRINCIPAL, {
    ...newAccount
  });
};

const updateAccountAsAdmin = async (account: IAccount) => {
  const newAccount = pick(account, [
    'id',
    'contractExpirationDate',
    'email',
    'firstName',
    'lastName',
    'phone',
    'type',
    'institutionId',
    'institutionName',
    'institutionPrivate',
    'status',
    'secondaryAccountAllowance',
    'publicAcquisitions'
  ]);
  await axios.put(admin_accountsAPI.MODIFY_PRINCIPAL_AS_ADMIN(account.id), {
    ...newAccount
  });
};

const addAccount = async (account: INewAccount) =>
  await axios.post(admin_accountsAPI.ADD_PRINCIPAL, { ...account });

// /* principal calls */
// const getPrincipalInfo = (id: string) => {
//   axios.get(usersAPI.PRINCIPAL_DATA(id)).then(({ data }) => {
//     getSuborderingInstitutions().then(
//       institutions =>
//         institutions &&
//         store.dispatch(
//           updateUser({
//             user: data,
//             institutions: institutions.data
//           })
//         )
//     );
//   });
// };

const getSecondaryAccounts = (id: string, callback: TCallback) => {
  axios
    .get(principal_accountsAPI.SECONDARY_ACCOUNTS(id))
    .then(({ data }) => callback(data));
};

const getAllSecondaryAccounts = async () =>
  await axios.get(principal_accountsAPI.GET_ALL);

const addSecondaryAccount = async (account: INewAccount) =>
  await axios.post(principal_accountsAPI.ADD_SECONDARY, { ...account });

const getSuborderingInstitutions = async () =>
  await axios.get(principal_accountsAPI.GET_SUBORDER_INST);

/* secondary calls */
// const getSecondaryInfo = (id: string) => {
//   axios
//     .get(usersAPI.SECONDARY_DATA(id))
//     .then(({ data }) => store.dispatch(updateUser({ user: data })));
// };

const updateSecondaryAccount = async (account: IFormSecondaryAccount) =>
  await axios.put(principal_accountsAPI.MODIFY_SECONDARY(account.id!), {
    ...account
  });

export {
  // getAdminInfo,
  getPrincipalAccounts,
  updateAccount,
  addAccount,
  // getPrincipalInfo,
  getSecondaryAccounts,
  addSecondaryAccount,
  // getSecondaryInfo,
  getAllSecondaryAccounts,
  updateSecondaryAccount,
  getSuborderingInstitutions,
  updateAccountAsAdmin
};
